<template>
  <Modal
    v-model="modal"
    :title="safe.TransactionPassword?$t('title.w22'):$t('title.w23')"
    :mask-closable="false"
  >
    <div>
      <ButtonSwitch :type.sync="resetType"></ButtonSwitch>
      <div class="content">
        <Form label-position="top" :model="form" ref="form" :rules="formRule">
          <FormItem
            :label="`${safe.TransactionPassword?$t('label.w33'):$t('label.w21')}`"
            prop="pwd"
          >
            <Input type="password" :placeholder="$t('pl.p3')" v-model="form.pwd" />
          </FormItem>
          <FormItem :label="$t('label.w34')" prop="pwdagain">
            <Input type="password" :placeholder="$t('pl.p4')" v-model="form.pwdagain" />
          </FormItem>
          <FormItem :label="`${resetType=='phone'?$t('label.w35'):$t('label.w36')}`" prop="code">
            <Row type="flex" :gutter="10">
              <Col span="18">
                <Input :placeholder="$t('pl.p8')" v-model="form.code" />
              </Col>
              <Col span="6">
                <Codebtn type="SendTransactionPasswordCode" :to="form" :disabled="pwdErr" />
              </Col>
            </Row>
          </FormItem>
        </Form>
      </div>
    </div>
    <template slot="footer">
      <Button type="primary" :disabled="pwdErr||form.code==''" @click="submit">{{$t('btn.b5')}}</Button>
    </template>
  </Modal>
</template>

<script>
import ButtonSwitch from "@/components/buttonSwitch";
import formRule from "@/libs/formRule";
import Rsa from "@/libs/Rsa";
import Codebtn from "@/components/sendCodeButton";
import { post } from "@/libs/axios";
export default {
  components: { ButtonSwitch, Codebtn },
  data() {
    const pwdCheckValidate = (rule, value, callback) => {
      if (this.form.pwd != value) {
        callback(new Error(this.$t("msg.m31")));
      } else {
        callback();
      }
    };
    return {
      resetType: "phone",
      modal: false,
      form: {
        pwd: "",
        pwdagain: "",
        code: "",
        type: 2
      },
      formRule: {
        pwd: formRule.logPwd,
        pwdagain: [
          { required: true, message: this.$t("msg.m32"), trigger: "blur" },
          { required: true, validator: pwdCheckValidate, trigger: "blur" }
        ],
        code: formRule.code
      }
    };
  },
  computed: {
    pwdErr() {
      return this.form.pwd == "" || this.form.pwd != this.form.pwdagain;
    },
    safe() {
      return this.$store.state.user.safe;
    }
  },
  watch: {
    resetType(v) {
      this.form.type = v == "phone" ? 2 : 1;
      this.$refs.form.resetFields();
    },
    modal(v) {
      if (v) {
        this.$refs.form.resetFields();
      }
    }
  },
  methods: {
    async submit() {
      // 提交前验证表单
      let valid = await this.$refs.form.validate();
      if (!valid) return;
      let res = await post("/Member/RZJProfile/SaveTransactionPassword", {
        passWord: Rsa(this.form.pwd),
        affirmPassWord: Rsa(this.form.pwdagain),
        verificationType: this.form.type,
        code: this.form.code
      });
      if (res.err) return res.throw();
      this.$Message.success(
        this.safe.TransactionPassword ? this.$t("msg.m33") : this.$t("msg.m34")
      );
      this.$store.dispatch("user/getSafe");
      this.modal = false;
    }
  }
};
</script>
